import { useQuery } from "@tanstack/react-query";
import { apiGet } from "../client";
import type { ISimpleUser } from "../exam_papers/getExamReport";
import type { IExamProgress } from "../exam_progress/types";
import type { IExamAssignment } from "./types";
import { QueryKeys } from "@/lib/query-keys";

export interface IProgressListItem {
  progress: IExamProgress;
  progress_rate: number;
  user: ISimpleUser;
}

export interface IExamAssignmentMonitorResponse {
  assignment: IExamAssignment;
  progress_list: IProgressListItem[];
}

export const useQueryGetExamAssignmentMonitor = (id: string) => {
  return useQuery({
    queryKey: QueryKeys.examAssignment.monitor(id),
    queryFn: async () => {
      const response = await apiGet<IExamAssignmentMonitorResponse>(
        `/exam_assignments/${id}/monitor`
      );
      return response.data;
    },
    enabled: !!id,
    refetchInterval: 10000, // 10초마다 자동으로 데이터를 다시 가져옵니다
  });
};
